<div #hoverTipRef class="hover-tip"><span class="version">Raised on Version: </span>{{ versionName }}</div>
